import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class Case extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() surgeon!: string;
    @Prop() room!: string;
    @Prop() role!: string;
    @Prop() start!: Date;
    @Prop() end!: Date;
  }